import { ProductItemDto } from "../../state/listing/product/models"
import { ProductDto } from "../../state/product/Product"
import { BundleItem } from "../../state/product/bundle/models/BundleItem"

export const handleTotalAmount = (i: BundleItem[]) => {
    const totalReducer = (accumulator, currentValue) => accumulator + currentValue.unitPrice * currentValue.quantity
    return i.reduce(totalReducer, 0)
}

export const mapItemKeyToItems = i => {
    return i.map(i => {
        return {
            ...i,
            itemKey: Math.floor(Math.random() * 1000000)
        }
    })
}

export const mapProductItemToBundleItem = (item: ProductItemDto): BundleItem => ({
    itemKey: Math.floor(Math.random() * 1000000),
    productId: item.id,
    title: item.title,
    unitPrice: item.defaultUnitPrice,
    unitOfMeasure: "1",
    unitCost: item.defaultUnitCost,
    quantity: "1",
    measure: "1",
    currency: item.currency,
    imageIds: item.imageIds || [],
    labels: item.labels || [],
    product: item,
})

export const mapProductDtoToProductItem = (item: ProductDto): ProductItemDto => ({
    id: item.id,
    ...item.attributes
})

export const calculateBundlePrice = (bundleProducts): number =>
    (bundleProducts || []).reduce((acc: number, cur: BundleItem) => {
        let price = 0
        if (Number(cur.quantity) > 0 && Number(cur.unitPrice) > 0) {
            price = Number(cur.quantity) * Number(cur.unitPrice)
        }
        return acc + price
    }, 0)



// WEBPACK FOOTER //
// ./src/utils/bundle/utils.ts